(function toggle() {
    var selectors = {
        ButtonFirst: '[data-first-button]',
        ContentFirst: '[data-first-content]',
        ButtonSecond: '[data-second-button]',
        ContentSecond: '[data-second-content]',
        ButtonThird: '[data-third-button]',
        ContentThird: '[data-third-content]'
    };
    // step 1
    // const question = document.querySelector('section')
    // question.addEventListener('click', () => {
    //   question.classList.toggle('opened')
    // })
    // step 2
    // const questions = document.querySelectorAll('section')
    // questions.forEach(question => {
    //   question.addEventListener('click', () => {
    //     question.classList.toggle('opened')
    //   })
    // })
    var featureSection = document.querySelectorAll('section.feature-section');
    if (featureSection.length) {
        document.querySelector(selectors.ButtonFirst).addEventListener('click', function () {
            document.querySelector(selectors.ContentThird).classList.add('hidden');
            document.querySelector(selectors.ButtonThird).classList.remove('outline-none');
            document.querySelector(selectors.ButtonThird).classList.remove('border-gray-500');
            document.querySelector(selectors.ButtonThird).classList.remove('border-500');
            document.querySelector(selectors.ButtonThird).classList.remove('ring-1');
            document.querySelector(selectors.ButtonThird).classList.remove('ring-gray-500');
            document.querySelector(selectors.ButtonThird).classList.remove('z-10');
            document.querySelector(selectors.ContentSecond).classList.add('hidden');
            document.querySelector(selectors.ButtonSecond).classList.remove('outline-none');
            document.querySelector(selectors.ButtonSecond).classList.remove('border-gray-500');
            document.querySelector(selectors.ButtonSecond).classList.remove('border-500');
            document.querySelector(selectors.ButtonSecond).classList.remove('ring-1');
            document.querySelector(selectors.ButtonSecond).classList.remove('ring-gray-500');
            document.querySelector(selectors.ButtonSecond).classList.remove('z-10');
            document.querySelector(selectors.ContentFirst).classList.remove('hidden');
            document.querySelector(selectors.ContentFirst).classList.add('flex');
            document.querySelector(selectors.ButtonFirst).classList.add('border-gray-500');
            document.querySelector(selectors.ButtonFirst).classList.add('border-500');
            document.querySelector(selectors.ButtonFirst).classList.add('ring-1');
            document.querySelector(selectors.ButtonFirst).classList.add('ring-gray-500');
            document.querySelector(selectors.ButtonFirst).classList.add('z-10');
        });
        //Second button
        document.querySelector(selectors.ButtonSecond).addEventListener('click', function () {
            document.querySelector(selectors.ContentFirst).classList.remove('flex');
            document.querySelector(selectors.ContentFirst).classList.add('hidden');
            document.querySelector(selectors.ButtonFirst).classList.remove('z-10');
            document.querySelector(selectors.ButtonFirst).classList.remove('ring-1');
            document.querySelector(selectors.ButtonFirst).classList.remove('ring-gray-500');
            document.querySelector(selectors.ButtonFirst).classList.remove('outline-none');
            document.querySelector(selectors.ButtonFirst).classList.remove('border-gray-500');
            document.querySelector(selectors.ButtonFirst).classList.add('border-gray-50');
            document.querySelector(selectors.ContentThird).classList.add('hidden');
            document.querySelector(selectors.ButtonThird).classList.remove('outline-none');
            document.querySelector(selectors.ButtonThird).classList.remove('border-gray-500');
            document.querySelector(selectors.ButtonThird).classList.remove('border-500');
            document.querySelector(selectors.ButtonThird).classList.remove('ring-1');
            document.querySelector(selectors.ButtonThird).classList.remove('ring-gray-500');
            document.querySelector(selectors.ButtonThird).classList.remove('z-10');
            document.querySelector(selectors.ContentSecond).classList.remove('hidden');
            document.querySelector(selectors.ContentSecond).classList.add('flex');
            document.querySelector(selectors.ButtonSecond).classList.add('outline-none');
            document.querySelector(selectors.ButtonSecond).classList.add('border-gray-500');
            document.querySelector(selectors.ButtonSecond).classList.add('border-500');
            document.querySelector(selectors.ButtonSecond).classList.add('ring-1');
            document.querySelector(selectors.ButtonSecond).classList.add('ring-gray-500');
            document.querySelector(selectors.ButtonSecond).classList.add('z-10');
        });
        //Third button
        document.querySelector(selectors.ButtonThird).addEventListener('click', function () {
            document.querySelector(selectors.ContentFirst).classList.remove('flex');
            document.querySelector(selectors.ContentFirst).classList.add('hidden');
            document.querySelector(selectors.ButtonFirst).classList.remove('outline-none');
            document.querySelector(selectors.ButtonFirst).classList.remove('border-gray-500');
            document.querySelector(selectors.ButtonFirst).classList.remove('border-500');
            document.querySelector(selectors.ButtonFirst).classList.remove('ring-1');
            document.querySelector(selectors.ButtonFirst).classList.remove('ring-gray-500');
            document.querySelector(selectors.ButtonFirst).classList.remove('z-10');
            document.querySelector(selectors.ContentSecond).classList.remove('flex');
            document.querySelector(selectors.ContentSecond).classList.add('hidden');
            document.querySelector(selectors.ButtonSecond).classList.remove('outline-none');
            document.querySelector(selectors.ButtonSecond).classList.remove('border-gray-500');
            document.querySelector(selectors.ButtonSecond).classList.remove('border-500');
            document.querySelector(selectors.ButtonSecond).classList.remove('ring-1');
            document.querySelector(selectors.ButtonSecond).classList.remove('ring-gray-500');
            document.querySelector(selectors.ButtonSecond).classList.remove('z-10');
            document.querySelector(selectors.ContentThird).classList.remove('hidden');
            document.querySelector(selectors.ContentThird).classList.add('flex');
            document.querySelector(selectors.ButtonThird).classList.add('outline-none');
            document.querySelector(selectors.ButtonThird).classList.add('border-gray-500');
            document.querySelector(selectors.ButtonThird).classList.add('border-500');
            document.querySelector(selectors.ButtonThird).classList.add('ring-1');
            document.querySelector(selectors.ButtonThird).classList.add('ring-gray-500');
            document.querySelector(selectors.ButtonThird).classList.add('z-10');
        });
    }
})();
export {};
